import { Calendar } from '@powerportalspro/react-calendar';

// Every sample appointment, not only one account's, so a weekday is full.
export function CalendarMonthLayoutSample() {
  return <Calendar defaultLayout="month" defaultTables={['appointment']} height="720px" />;
}
